import axios from "./request";
const getLocalUserInfo = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  return user || {};
};
export const getUserInfo = id => {
  //获取用户信息
  const data = new FormData();
  const { id: uid } = getLocalUserInfo();
  data.append("type", 1);
  data.append("id", id || uid);
  return axios.post("/personal", data);
};

export const EditUserInfo = (
  //修改个人基本信息
  params
) => {
  const { id, head_portrait, nickname, phone, unit } = params;
  const data = new FormData();
  data.append("id", id);
  data.append(
    "head_portrait",
    head_portrait && head_portrait[0] ? head_portrait[0].url : "/avatar.png"
  );
  data.append("nickname", nickname);
  data.append("phone", phone);
  data.append("type", 2);
  data.append("unit", unit);
  return axios.post("/personal", data);
};
export const EditUserPhone = (
  //修改个人手机号
  params
) => {
  const { id, phone } = params;
  const data = new FormData();
  data.append("id", id);
  data.append("phone", phone);
  data.append("type", 2);
  return axios.post("/personal", data);
};
export const EditUserPassword = (
  //修改个人密码
  params
) => {
  const { id, password } = params;
  const data = new FormData();
  data.append("id", id);
  data.append("password", password);
  data.append("type", 2);
  return axios.post("/personal", data);
};

export const MeGetMessageList = params => {
  const { page, m_type, title, status, num, name } = params;
  const data = new FormData();
  const { id } = getLocalUserInfo();
  data.append("page", page);
  data.append("m_type", m_type);
  data.append("status", status || "");
  if (m_type == "5") {
    data.append("name", name || "");
    data.append("title", "");
  } else {
    data.append("title", title || "");
  }
  data.append("uid", id || "");
  data.append("is_user", "");
  data.append("is_admin", "");
  data.append("num", num);
  return axios.post("/select_message", data);
};

export const GetApplyList = page => {
  const data = new FormData();
  try {
    const { id: uid } = getLocalUserInfo();
    data.append("uid", uid);
  } catch (error) {
    data.append("uid", "");
  }
  data.append("type", 1);
  data.append("page", page);
  return axios.post("/apply_list", data);
};
export const ReadApplyList = id => {
  const data = new FormData();
  data.append("type", 2);
  data.append("id", id);
  return axios.post("/apply_list", data);
};
export const GetSMS = phone => {
  const data = new FormData();
  data.append("phone", phone);
  return axios.post("/yunxin_note", data);
};

export const VerifyCode = (code, phone) => {
  const data = new FormData();
  data.append("code", code);
  data.append("phone", phone);
  return axios.post("/verify_code", data);
};

export const GetIdByPhone = phone => {
  const data = new FormData();
  data.append("phone", phone);
  return axios.post("/phone_user", data);
};

export const UserAddProjects = params => {
  const { id: uid } = getLocalUserInfo();
  const {
    is_project,
    phone,
    poid,
    file,
    issue,
    file_name,
    project_name
  } = params;
  const data = new FormData();
  data.append("is_project", is_project);
  data.append("uid", uid);
  data.append("phone", phone);
  data.append("poid", poid);
  data.append("project_name", project_name);
  if (is_project === 1) {
    data.append("file", file && file[0] ? file[0].url : "");
    data.append("file_name", file_name);
  }
  if (is_project === 2) {
    data.append("issue", issue);
  }
  return axios.post("/add_project_classify", data);
};

export const UserUpdateProjects = params => {
  const { id: uid } = getLocalUserInfo();
  const { is_project, phone, poid, file, file_name, project_name, id } = params;
  const data = new FormData();
  data.append("is_project", is_project);
  data.append("uid", uid);
  data.append("phone", phone);
  data.append("poid", poid);
  data.append("project_name", project_name);
  data.append("id", id);
  data.append("file", file && file[0] ? file[0].url : "");
  data.append("file_name", file_name);
  data.append("status", 0);
  return axios.post("/up_project_classify", data);
};



// WEBPACK FOOTER //
// ./src/request/me.js